import React from "react";
import GorgiasSettingsContainer from "./GorgiasSettingsContainer";

export default function GorgiasSettings({msgDataSources, mode}) {

    return (
        <>
            {
                msgDataSources && msgDataSources?.map((msgDataSource, index) =>
                    <GorgiasSettingsContainer
                        key={index}
                        msgDataSource={msgDataSource}
                        mode={mode}
                    />
                )
            }
        </>
    )
}